var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group mb-3 w-100",attrs:{"role":"group"}},[_c('input',{ref:"dateRangePickerInput",staticClass:"form-control",staticStyle:{"background-color":"white !important"},attrs:{"type":"text"}}),(_vm.isDateSelected)?_c('b-button',{on:{"click":_vm.clearDate}},[_c('b-icon',{attrs:{"icon":"trash"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }